import { useState, useEffect } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import Forclick from './Forclick'
import './index.scss'

const Project = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container project-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['P', 'r', 'o', 'j', 'e', 'c', 't']}
              idx={15}
            />
          </h1>
          <h2>Please click the project name and see my projects</h2>
        </div>
        <div className="project-container">
          <Forclick />
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Project
